var map = {
	"./client (1).jpg": "0155",
	"./client (10).jpg": "6bbe",
	"./client (2).jpg": "7bf4",
	"./client (3).jpg": "771a",
	"./client (4).jpg": "4010",
	"./client (5).jpg": "9c91",
	"./client (6).jpg": "3bea",
	"./client (7).jpg": "0d66",
	"./client (8).jpg": "1297",
	"./client (9).jpg": "54fc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "db00";